var locale = {
  placeholder: 'انتخاب زمان'
};
export default locale;
//# sourceMappingURL=fa_IR.js.map
